/** Prospects — CRM-lite for agents/brokers. Isolated from buyer/seller checklist state. */

export const PROSPECTS_PREFIX = "dh_prospects_";
export const PROSPECTS_EVENT = "dh-prospects-change";

export const INTEREST_LEVELS = [
  { id: "cool", label: "Cool" },
  { id: "warm", label: "Warm" },
  { id: "hot", label: "Hot" },
];

export const CONTACT_METHODS = [
  { id: "email", label: "Email" },
  { id: "phone", label: "Phone" },
  { id: "either", label: "Either" },
];

export const CONTACT_REASONS = [
  { id: "buying", label: "Buying a home" },
  { id: "selling", label: "Selling a home" },
  { id: "both", label: "Buying and selling" },
  { id: "visit", label: "Schedule a visit" },
  { id: "referral", label: "Referral" },
  { id: "general", label: "General question" },
];

export const FOLLOW_STATUSES = [
  { id: "scheduled", label: "Scheduled" },
  { id: "done", label: "Done" },
];

export function interestFromReason(reason) {
  if (reason === "buying" || reason === "selling" || reason === "both") return "hot";
  if (reason === "visit" || reason === "referral") return "warm";
  return "cool";
}

export function followDaysForInterest(interest) {
  if (interest === "hot") return 3;
  if (interest === "warm") return 5;
  return 7;
}

export function addDaysStamp(days, from = new Date()) {
  const next = new Date(from);
  next.setDate(next.getDate() + Number(days || 0));
  const year = next.getFullYear();
  const month = String(next.getMonth() + 1).padStart(2, "0");
  const day = String(next.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function isFollowOverdue(row) {
  if (!row || row.status === "converted" || row.follow_status === "done") return false;
  if (!row.next_contact) return false;
  return row.next_contact < addDaysStamp(0);
}

export function canManageProspects(session) {
  return session?.role === "agent" || session?.role === "broker";
}

export function canViewProspects(session) {
  return canManageProspects(session) || session?.role === "admin";
}
